<template>
  <div v-if="pageText" v-html="pageText" class="gp-has-header"/>
</template>

<script>
import api from '../services/groupsPlaceApi.js'

export default {
  name: 'page-preview',
  data() {
    return {
      pageText: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", false)
    let url = "/user/pagePreview/" + this.$route.params.id
    api.get(url).then(
      (results) => {
        this.pageText = results.data.pageText
      },
      (error) => {
        this.$notify.error({message: "Error fetching page.", timeOut: 5000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  }

};
</script>
